module.exports = __webpack_public_path__ + "img/zhaoxizi.cdf04f7f.jpg";